import MockAdapter from "axios-mock-adapter";
import { useNavigate } from "react-router-dom";
import * as ReactStripe from "@stripe/react-stripe-js";

export default (axios) => {
  console.log(`Using mocked API.`);

  ReactStripe.useStripe = () => {
    console.log(`Using mocked Stripe.`);

    const navigate = useNavigate();

    return {
      confirmPayment() {
        const customer = "d77a6ea2-b64d-4b83-bb8e-c03443ff894d";
        const paymentIntent = "XXX";
        navigate(`/summary?customer=${customer}&payment_intent=${paymentIntent}`);
      },
    };
  };

  const mock = new MockAdapter(axios);

  // checkout
  mock.onPost("/get_prices").reply(200, {
    user: {
      professional: 5,
      enterprise: 10,
      starter: 10,
    },
    concurrent: {
      professional: 10,
      enterprise: 20,
      starter: 20,
    },
    vpn: 8
  });

  mock.onPost("/validate_email").reply(200, {});

  mock.onPost("/validate_otp").reply(200, {});

  mock.onPost("/create_subscription").reply(200, {
    secret: "pi_3MPPUtAFFsxze3ci1vRCELuJ_secret_6yY9NLyDJ19hGGUS61G0yzxcs",
    subscriptionId: "9b1056ff-4dc8-49e4-9985-9045a3a06427",
  });

  mock.onPost("/update_subscription").reply(200, {});

  mock.onPost("/get_activation_key").reply(200, {
    key: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJrZXlfdHlwZSI6ImFjdGl2YXRpb24iLCJhY3RpdmF0aW9uX2tleV92ZXJzaW9uIjoxLCJlbnRpdGxlbWVudF9pZCI6ImZmMjE2ZjFiLTEyN2UtNGNlMS04M2IyLTc0ZTExNTljODc3YiIsImxpY2Vuc2VfdHlwZSI6IiIsInNrdSI6IiIsImlzc3VlZF90byI6IiIsImF1ZCI6InVybjprYXNtIiwiaXNzIjoiS2FzbSBUZWNobm9sb2dpZXMiLCJleHAiOjE1MTYyMzkwMjIsImlhdCI6MTUxNjIzOTAyMn0.ZafZOcrGNx6sy9W9juHAB4w31QjeXFf0KahJBJXZtdU",
  });

  // license
  mock.onPost("/activate").reply(200, {
    license_key: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.e30.Et9HFtf9R3GEMA0IICOfFMVXY7kkTX1wr4qCyhIf58U"
  });
};
